/**
 * Created by asiulik on 01.12.2017.
 */

define(['jquery', 'lodash', 'eventEmitter/EventEmitter', './overlayDefault', './overlayVideo', './overlayPage', './overlaySlider', './overlayCalculator', './overlayTermin', './overlayShare'], function($, _, EventEmitter, OverlayDefault, OverlayVideo, OverlayPage, OverlaySlider, OverlayCalculator, OverlayTermin, OverlayShare){

    function Overlay(overlayInstance){

        var _this = this;

        this.overlay = overlayInstance

        window.addEventListener('forceHideOverlay', function(){
            _this.overlay.hideOverlay();
        });

    }

    Overlay.prototype = _.clone(EventEmitter.prototype);

    Overlay.prototype.init = function(){

        var _this = this;

        this.overlayDefault = new OverlayDefault(
            this.overlay
        );

        this.overlayVideo = new OverlayVideo(
            this.overlay
        );

        this.overlayPage = new OverlayPage(
            this.overlay
        );

        this.overlaySlider = new OverlaySlider(
            this.overlay
        );

        this.overlayCalculator = new OverlayCalculator(
            this.overlay
        );

        this.overlayTermin = new OverlayTermin(
            this.overlay
        );

        this.overlayShare = new OverlayShare(
            this.overlay
        );

        this.overlayDefault.init();
        this.overlayVideo.init();
        this.overlayPage.init();
        this.overlaySlider.init();
        this.overlayCalculator.init();
        this.overlayTermin.init();
        this.overlayShare.init();

        this.overlayPage.on('overlay:page:contentAdded', function($contentCollection){
            _this.emit('overlay:page:contentAdded', $contentCollection);
        });

        this.overlayTermin.on('overlay:page:contentAdded', function(){
            _this.emit('overlay:page:contentAdded', 'x');
        });

        this.overlayTermin.on('overlay:page:contentAdded', function(){
            _this.emit('overlay:page:contentAdded', 'x');
        });

        this.overlayShare.on('overlay:share:favsBeforeOpen', function(){
            _this.emit('overlay:share:favsBeforeOpen');
        });

        this.overlayCalculator.on('overlay:calculator:calculateBeforeOpen', function(productData){
            _this.emit('overlay:calculator:calculateBeforeOpen', productData);
        });

    };

    Overlay.prototype.getOverlays = function(){

        return {
            overlayVideo: this.overlayVideo,
            overlayPage: this.overlayPage,
            overlaySlider: this.overlaySlider,
            overlayCalculator: this.overlayCalculator,
            overlayTermin: this.overlayTermin,
            overlayDefault: this.overlayDefault,
            overlayShare: this.overlayShare
        }

    };

    return Overlay;

});



// WEBPACK FOOTER //
// ./Private/Scripts/modules/overlays/overlays.js